import { createAction } from "@reduxjs/toolkit";

import { Events } from "@js/services/analytics";
import type { AppDispatch } from "@js/store";

import type {
  EmployerReferralsOrderByType,
  ReferType,
  TalentReferralsOrderByType,
  UserReferralType,
} from "./types";

const clientReferralCopyLinkClicked = createAction(
  Events.CLIENT_REFERRAL_COPY_LINK,
);

const clientReferralEmailLinkClicked = createAction(
  Events.CLIENT_REFERRAL_EMAIL_LINK,
);

const clientReferralLinkedInLinkClicked = createAction(
  Events.CLIENT_REFERRAL_LINKEDIN_LINK,
);

const clientReferralTwitterLinkClicked = createAction(
  Events.CLIENT_REFERRAL_TWITTER_LINK,
);

const talentReferralCopyLinkClicked = createAction(
  Events.TALENT_REFERRAL_COPY_LINK,
);

const talentReferralEmailLinkClicked = createAction(
  Events.TALENT_REFERRAL_EMAIL_LINK,
);

const talentReferralLinkedInLinkClicked = createAction(
  Events.TALENT_REFERRAL_LINKEDIN_LINK,
);

const talentReferralTwitterLinkClicked = createAction(
  Events.TALENT_REFERRAL_TWITTER_LINK,
);

const clientReferralSortOrderClicked = createAction<{
  sortBy: EmployerReferralsOrderByType;
}>(Events.REFERRAL_CLIENT_SORT_ORDER);

const talentReferralSortOrderClicked = createAction<{
  sortBy: TalentReferralsOrderByType;
}>(Events.REFERRAL_TALENT_SORT_ORDER);

const clientReferralCSVClicked = createAction(Events.CLICK_REFERRAL_CLIENT_CSV);

const talentReferralCSVClicked = createAction(Events.CLICK_REFERRAL_TALENT_CSV);

export type ReferralActionTypes =
  | ReturnType<typeof clientReferralCopyLinkClicked>["type"]
  | ReturnType<typeof clientReferralEmailLinkClicked>["type"]
  | ReturnType<typeof clientReferralLinkedInLinkClicked>["type"]
  | ReturnType<typeof clientReferralTwitterLinkClicked>["type"]
  | ReturnType<typeof clientReferralSortOrderClicked>["type"]
  | ReturnType<typeof clientReferralCSVClicked>["type"]
  | ReturnType<typeof talentReferralCopyLinkClicked>["type"]
  | ReturnType<typeof talentReferralEmailLinkClicked>["type"]
  | ReturnType<typeof talentReferralLinkedInLinkClicked>["type"]
  | ReturnType<typeof talentReferralTwitterLinkClicked>["type"]
  | ReturnType<typeof talentReferralSortOrderClicked>["type"]
  | ReturnType<typeof talentReferralCSVClicked>["type"];

export const clickCopyLink = (type: ReferType) => (dispatch: AppDispatch) => {
  if (type === "job") return;

  if (type === "client") return dispatch(clientReferralCopyLinkClicked());

  if (type === "talent") return dispatch(talentReferralCopyLinkClicked());
};

export const clickEmailLink = (type: ReferType) => (dispatch: AppDispatch) => {
  if (type === "job") return;

  if (type === "client") return dispatch(clientReferralEmailLinkClicked());

  if (type === "talent") return dispatch(talentReferralEmailLinkClicked());
};

export const clickLinkedInLink =
  (type: ReferType) => (dispatch: AppDispatch) => {
    if (type === "job") return;

    if (type === "client") return dispatch(clientReferralLinkedInLinkClicked());

    if (type === "talent") return dispatch(talentReferralLinkedInLinkClicked());
  };

export const clickTwitterLink =
  (type: ReferType) => (dispatch: AppDispatch) => {
    if (type === "job") return;

    if (type === "client") return dispatch(clientReferralTwitterLinkClicked());

    if (type === "talent") return dispatch(talentReferralTwitterLinkClicked());
  };

export const clickSortReferrals =
  (
    type: UserReferralType,
    payload: {
      sortBy: EmployerReferralsOrderByType | TalentReferralsOrderByType;
    },
  ) =>
  (dispatch: AppDispatch) => {
    if (type === "client")
      return dispatch(
        clientReferralSortOrderClicked(
          payload as {
            sortBy: EmployerReferralsOrderByType;
          },
        ),
      );

    if (type === "talent")
      return dispatch(
        talentReferralSortOrderClicked(
          payload as {
            sortBy: TalentReferralsOrderByType;
          },
        ),
      );
  };

export const clickReferralsCSV =
  (type: UserReferralType) => (dispatch: AppDispatch) => {
    if (type === "client") return dispatch(clientReferralCSVClicked());

    if (type === "talent") return dispatch(talentReferralCSVClicked());
  };
